import { Facet } from '../Facet';
import { IItemCacheSelector } from '../IItemCacheObserver';

export interface IComputedItemFacetProps {
  itemKey: string | undefined;
}

/**
 * Facet type which provides a built-in computation function to determine its current value
 * in the cache for a given item.
 */
export class ComputedItemFacet<TResult> extends Facet<TResult> {
  /**
   * Computes the value of this facet for an item given the current state of the item cache.
   */
  public readonly compute: IItemCacheSelector<TResult | undefined, IComputedItemFacetProps>;

  /**
   * Creates a new computed item facet with a given computation function.
   */
  constructor(name: string, compute: IItemCacheSelector<TResult | undefined, IComputedItemFacetProps>) {
    super(name);

    this.compute = compute;
  }
}
